import React, {useEffect, useState} from "react";
import classNames from "classnames";
import "./index.scss";
import PortalServiceMap from "../PortalMap/PortalServiceMap.jsx";
import MarkerIcons from "../../../services/markericons.js";
import {ICONS_COURIER_MARKER, TYPE_MARKER} from "../../../utils/enums.js";

const SectionItemMapByLocation = ({item, value, column, onPropChange}) => {
    const [markers, setMarkers] = useState([]);

    const scooterIcon = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 336.085 336.085" style="enable-background:new 0 0 336.085 336.085;" xml:space="preserve"><path d="M296.179,241.082l-26.336-216.04l11.801,0c3.559,0,6.663-2.743,6.77-6.3c0.11-3.681-2.841-6.7-6.497-6.7l-39.556,0 c-3.559,0-6.663,2.743-6.77,6.3c-0.11,3.681,2.841,6.7,6.497,6.7h14.658l21.747,178.391c-0.396,0.312-57.554,72.609-57.554,72.609 H99.775l-3.034-12.987c-6.651-28.471-31.715-48.355-60.952-48.355H17.37c-3.559,0-6.663,2.743-6.77,6.3 c-0.11,3.681,2.841,6.7,6.497,6.7h18.691c23.043,0,43.05,15.872,48.292,38.311l2.343,10.032h-3.936 c-3.285-20.793-22.065-36.504-44.105-34.885c-20.369,1.496-36.823,17.987-38.276,38.359c-1.729,24.246,17.508,44.527,41.393,44.527 c20.672,0,37.858-15.194,40.987-35.001h142.358c1.512,0,2.94-0.692,3.876-1.879l51.954-65.819l2.594,21.278 c-18.321,5.2-31.527,22.688-30.077,42.956c1.46,20.391,17.927,36.875,38.317,38.352c24.266,1.758,44.575-17.489,44.575-41.389 C336.085,260.193,318.325,241.924,296.179,241.082z M41.501,311.043C25.785,311.043,13,298.258,13,282.542 c0-15.715,12.785-28.5,28.501-28.5c13.478,0,24.793,9.408,27.743,22H41.501c-3.59,0-6.5,2.91-6.5,6.5s2.91,6.5,6.5,6.5h27.743 C66.294,301.635,54.979,311.043,41.501,311.043z M294.585,311.043c-15.715,0-28.5-12.785-28.5-28.501 c0-12.305,7.84-22.813,18.786-26.793l3.179,26.079c0.401,3.297,3.205,5.715,6.444,5.715c0.262,0,0.527-0.017,0.794-0.049 c3.563-0.435,6.101-3.675,5.666-7.238l-3.173-26.03c14.215,1.595,25.304,13.683,25.304,28.316 C323.085,298.258,310.3,311.043,294.585,311.043z"/></svg>';

    const createMarkerCourier = (location) => {
        let marker = {};

        const textValue = scooterIcon;
        const courierColor = null;

        marker.id = 1;
        marker.icon = MarkerIcons.instance.addItemCourier(
            ICONS_COURIER_MARKER.courier,
            courierColor,
            textValue
        );
        marker.content = null;
        marker.center = location;
        marker.markerType = TYPE_MARKER.courier;
        marker.location = location;
        marker.controlCenterId = null;
        marker.zIndex = 1;

        return marker;
    }

    useEffect(() => {
        const result = [];

        if(item[column.accessor]) {
            result.push(createMarkerCourier(item[column.accessor]));
        }

        setMarkers(result);

        // eslint-disable-next-line
    }, [column]);



    const handleOnMapClick = () => {
    };

    const handleOnRegionChange = () => {
    };

    return (
        <div className={classNames("sectionItemMapByLocation")}>
            <PortalServiceMap
                markers={markers}
                center={item[column.accessor] ? item[column.accessor] : null}
                region={null}
                circle={null}
                boundsByRegion={column.boundsByRegion}
                boundsByCircle={column.boundsByCircle}
                isHidePolygon={column.isHidePolygon}
                isReadonly={column.isReadonly}
                handleOnMapClick={handleOnMapClick}
                onRegionChange={handleOnRegionChange}
            />
        </div>
    );
}

export default SectionItemMapByLocation;
